import { IAttribute, IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { CustomizerFilter, FilterOption } from '../models';

export const getApplicableFilters = (groups: IProductWithAttributes[] = [], filters: CustomizerFilter[] = []): CustomizerFilter[] => {
  for (const filter of filters) {
    let allOptions = [];

    for (const group of groups) {
      const attributes = group.attributes.filter((a: IAttribute) => a.key === filter.name);
      if (attributes.length === 0) {
        continue;
      }

      const options = filter.options.filter((o: FilterOption) => attributes.some((a: IAttribute) => a.valueKey === o.value));
      options.forEach((o: FilterOption): void => { o.visible = true; });
      allOptions = allOptions.concat(options);
    }

    filter.available = (allOptions.length > 0);
  }

  return filters.filter((f: CustomizerFilter) => f.available);
};
